<template>
    <div v-if="config.display" :style="{'width': config.width || '100%'}" class="control e-control" :class="{ 'inline-label': config.inlineLabel, 'inline-label label-reverse': config.inlineLabelReverse }">
        <label-wrapper v-if="config.type !== 'checkbox'" :label-settings="config"></label-wrapper>
        <div v-if="asField" class="input-type-container">
            <display-value :id="config.id" :value="value" v-if="asField"></display-value>
        </div>
        <div v-else class="input-type-container">
            <div v-if="config.type == 'boolean' || config.type == ''">
                <ejs-switch v-bind="syncfusionConfig"
                            :checked="value"
                            @change="localChange($event);"
                            :ref="ref"
                            :data-test-id="dataTestId"
                            :disabled="config.disabled"
                ></ejs-switch>
                <span class="on-off-label">{{value ? syncfusionConfig.onLabel : syncfusionConfig.offLabel}}</span>
            </div>
            <div v-else>
                <ejs-checkbox
                    v-bind="syncfusionConfig"
                    :label="ddStoreFilter(config.label)"
                    :checked="value"
                    v-on:change="localChange($event);"
                    :ref="ref"
                    :data-test-id="dataTestId"
                    :disabled="config.disabled"
                ></ejs-checkbox>
                <sam-tooltip
                    v-if="labelSettings.helpText"
                    ref="tooltip"
                    opensOn="Click"
                    :css-class="labelSettings.tooltipClasses"
                    :content="labelSettings.helpText"
                    :show-with-empty-label="labelSettings.showWithEmptyLabel"
                    :label-classes="labelSettings.tooltipLabelClasses"
                ></sam-tooltip>
            </div>
        </div>
        <p v-if="config.message" class="input-info" v-html="ddStoreFilter(config.message)"></p>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { controlMixins } from "./controlMixins.js";

let editorSettings = {
    onchange: {
        type: 'actionfield',
        label: 'Change Action',
        itemsSource: 'actionStore.getActionOptions()',
        fields: {
            text: 'text',
            value: 'value'
        },
        default: {
            action: '',
            params: {}
        }
    }
};

export const checkboxComponent = {
    editorSettings: editorSettings,
    mixins: [controlMixins],
    methods: {
        localChange(tmpEvent) {
            this.value = !this.value;
            // return value if label contains link
            if (tmpEvent?.event?.srcElement?.tagName === 'A') {
                this.$nextTick(() => {
                    this.value = !this.value;
                });
            } else {
                this.action(tmpEvent, 'onchange');
            }
        }
    },
    computed: {
        ref() {
            return this.config.ref || this.config.id;
        },
        labelSettings() {
            let tooltipId = (this.name || this.id) + '_tooltip';
            let tooltipPosition = ' TopCenter';
            return {
                tooltipClasses: 'label-wrapper-tooltip ' + tooltipId + tooltipPosition,
                tooltipLabelClasses: 'e-icons e-info help-tooltip ' + tooltipId,
                helpText: this.config.helpText,
                showWithEmptyLabel: this.config.showWithEmptyLabel
            };
        }
    },
    components: {
        "ejs-switch": defineAsyncComponent(() => import('@common/syncfusion/switch')),
        "ejs-checkbox": defineAsyncComponent(() => import('@common/syncfusion/checkbox')),
        'sam-tooltip': defineAsyncComponent(() => import('@common/control/samTooltip')),
    }
};

export default checkboxComponent;
</script>

<style lang="css" scoped>
.switch-input {
    margin: 30px 0;
}
.toggle-status {
    margin-left: 10px;
}
.toggle-on {
    color: #2E7F5B;
}
.switch-input-label {
    margin-left: 20px;
}
.input-info {
    margin-top: 5px;
    color: #2973b7;
}
.on-off-label {
    font-size: 14px;
    line-height: 30px;
    margin-left:5px;
}
.inline-label {
    display: flex;
    align-items: flex-end;
}
.label-reverse > div:first-child {
    order: 2;
}
.label-reverse > div:nth-child(1) {
    margin-left: 5px;
}

:deep(.e-tooltip) {
    margin-left: 10px;
}

:deep(.input-type-container) {
    min-height: 20px;
}
</style>
